import _file0 from './NEMAT Truck and Dual Sport.geojson?url';
import _file1 from './North-Central MN ADV Trail.geojson?url';
import _file2 from './SEMAT REVISED.geojson?url';

export default {
    "NEMAT Truck and Dual Sport": _file0,
    "North-Central MN ADV Trail": _file1,
    "SEMAT REVISED": _file2,
};
